var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-static"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"text-truncate"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }